<template>
  <div>
      <maintenanceStatistics ></maintenanceStatistics>
  </div>
</template>

<script>
export default {
  components: {
    maintenanceStatistics: () => import('../common/maintenanceStatistics')
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {

  },
  computed: {
  },
  watch: {

  }
}
</script>
